import React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { useSelector } from "react-redux";
import DriverEarning from './DriverEarning';
import { useParams } from 'react-router-dom';
import Earningreports from './Earningreports';
import { useTranslation } from "react-i18next";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AllReports() {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);
  const auth = useSelector(state => state.auth);
  const { fleetAdminId, fleetAdminName } = useParams();

  if (!auth.profile) return;


  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          aria-label="tabs"
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          {(auth.profile.usertype === "fleetadmin" || auth.profile.usertype === "admin" || fleetAdminId) &&
            <Tab style={{ marginRight: "20px" }} label={t('driver_earning')} {...a11yProps(0)} />
          }
          {(auth.profile.usertype === "admin" && !fleetAdminId) &&
            <Tab style={{ marginRight: "20px" }} label={t('earning_reports')} {...a11yProps(1)} />
          }
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <DriverEarning fleetAdminId={fleetAdminId} fleetAdminName={fleetAdminName} />
      </TabPanel>
      {auth.profile.usertype === "admin" && !fleetAdminId && (
        <TabPanel value={value} index={1}>
          <Earningreports />
        </TabPanel>
      )}
    </Box>
  );
}